/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ExecuteWalletTopUpPaymentRequest,
  ExecuteWalletTopUpPaymentResponse,
  PrepareWalletTopUpPaymentRequest,
  PrepareWalletTopUpPaymentResponse,
  WalletTopUpInfo,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class WalletTopUpsControllerV1<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags wallet-top-ups-controller-v-1
   * @name PrepareTopUpPayment
   * @request POST:/api/v1/wallets/{walletId}/top-ups/open-banking/prepare
   */
  prepareTopUpPayment = (
    walletId: string,
    data: PrepareWalletTopUpPaymentRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PrepareWalletTopUpPaymentResponse, any>({
      path: `/v1/wallets/${walletId}/top-ups/open-banking/prepare`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareTopUpPaymentPath = '/v1/wallets/${walletId}/top-ups/open-banking/prepare'
  static prepareTopUpPaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags wallet-top-ups-controller-v-1
   * @name ExecuteTopUpPayment
   * @request POST:/api/v1/wallets/{walletId}/top-ups/open-banking/execute
   */
  executeTopUpPayment = (
    walletId: string,
    data: ExecuteWalletTopUpPaymentRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExecuteWalletTopUpPaymentResponse, any>({
      path: `/v1/wallets/${walletId}/top-ups/open-banking/execute`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static executeTopUpPaymentPath = '/v1/wallets/${walletId}/top-ups/open-banking/execute'
  static executeTopUpPaymentMethod = 'POST'
  /**
   * No description
   *
   * @tags wallet-top-ups-controller-v-1
   * @name GetWalletTopUpInfo
   * @request GET:/api/v1/wallets/{walletId}/top-ups/info
   */
  getWalletTopUpInfo = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletTopUpInfo, any>({
      path: `/v1/wallets/${walletId}/top-ups/info`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getWalletTopUpInfoPath = '/v1/wallets/${walletId}/top-ups/info'
  static getWalletTopUpInfoMethod = 'GET'
}
